(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Header-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hs-slideshow')) {
    class HsSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hs__track');
        this.slides = Array.from(this.querySelectorAll('.hs__slide'));
        this.dots = Array.from(this.querySelectorAll('.hs__dot'));
        this.prevBtn = this.querySelector('.hs__arrow--prev');
        this.nextBtn = this.querySelector('.hs__arrow--next');
        this.index = 0;
        this.lockUntil = 0;

        if (!this.track || this.slides.length < 2) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.reducedMotion) this.classList.remove('hs--autoplay');

        this.onClick = (event) => {
          const dot = event.target.closest('.hs__dot');
          if (dot) return this.goTo(this.dots.indexOf(dot));
          if (event.target.closest('.hs__arrow--prev')) return this.goTo(this.index - 1);
          if (event.target.closest('.hs__arrow--next')) return this.goTo(this.index + 1);
        };

        this.onAnimationEnd = (event) => {
          if (event.animationName === 'hs-progress') this.goTo(this.index + 1);
        };

        this.onBlockSelect = (event) => {
          const slide = event.target.closest('.hs__slide');
          const index = this.slides.indexOf(slide);
          if (index < 0) return;
          this.classList.add('is-editing');
          this.goTo(index, true);
        };

        this.onBlockDeselect = () => this.classList.remove('is-editing');

        this.addEventListener('click', this.onClick);
        this.addEventListener('animationend', this.onAnimationEnd);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.slideObserver = new IntersectionObserver(
          (entries) => {
            if (Date.now() < this.lockUntil) return;
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.slideObserver.observe(slide));

        this.viewObserver = new IntersectionObserver(
          ([entry]) => this.classList.toggle('is-offscreen', !entry.isIntersecting),
          { threshold: 0.15 }
        );
        this.viewObserver.observe(this);

        this.update();
      }

      disconnectedCallback() {
        if (this.slideObserver) this.slideObserver.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('animationend', this.onAnimationEnd);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      goTo(index, instant) {
        const count = this.slides.length;
        const target = ((index % count) + count) % count;
        this.lockUntil = Date.now() + 800;
        this.track.scrollTo({
          left: this.slides[target].offsetLeft,
          behavior: instant || this.reducedMotion ? 'auto' : 'smooth',
        });
        this.setActive(target);
      }

      setActive(index) {
        if (index < 0 || index === this.index) return;
        this.index = index;
        this.update();
      }

      update() {
        const last = this.slides.length - 1;

        this.slides.forEach((slide, i) => {
          slide.toggleAttribute('inert', i !== this.index);
        });

        this.dots.forEach((dot, i) => {
          const active = i === this.index;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        if (this.prevBtn) this.prevBtn.hidden = this.index === 0;
        if (this.nextBtn) this.nextBtn.hidden = this.index === last;
      }
    }

    customElements.define('hs-slideshow', HsSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function loadFonts(root) {
      var scope = root || document;
      var els = scope.querySelectorAll('[data-hero2-font-url]');
      Array.prototype.forEach.call(els, function (el) {
        if (el.getAttribute('data-hero2-font-loaded') === '1') return;
        el.setAttribute('data-hero2-font-loaded', '1');
        if (!('FontFace' in window)) return;
        var family = el.getAttribute('data-hero2-font-family');
        var url = el.getAttribute('data-hero2-font-url');
        if (!family || !url) return;
        try {
          var face = new FontFace(family, 'url("' + url + '")', {
            weight: String(el.getAttribute('data-hero2-font-weight') || 'normal'),
            style: el.getAttribute('data-hero2-font-style') || 'normal',
            display: 'swap'
          });
          face.load().then(function (loaded) {
            document.fonts.add(loaded);
          }).catch(function () {});
        } catch (e) {}
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { loadFonts(); });
    } else {
      loadFonts();
    }

    document.addEventListener('shopify:section:load', function (event) {
      loadFonts(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
